import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllPlanoContaCadastro } from '../service';
import {
  LIST_PLANO_CONTA_CADASTRO,
  LIST_PLANO_CONTA_CADASTRO_PENDING,
  LIST_PLANO_CONTA_CADASTRO_SUCCESS,
  LIST_PLANO_CONTA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllPlanoContaCadastro(action) {
  yield put({ type: LIST_PLANO_CONTA_CADASTRO_PENDING })

  try {
    const list = yield call(findAllPlanoContaCadastro)
    
    yield put({ type: LIST_PLANO_CONTA_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_PLANO_CONTA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllPlanoContaCadastro() {
  yield takeLatest(LIST_PLANO_CONTA_CADASTRO, sagaListAllPlanoContaCadastro)
}